import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"

import iosSvg from "images/home/new_home/ios_download.svg?raw"
import androidSvg from "images/home/new_home/google_play.svg?raw"

import { verifyPhoneNumber } from "shared/lib/verify_phone_number"
import { sendDownloadLink } from "shared/lib/graphql"

import styles from "./sms_form.module.scss"

export default class SMSForm extends Component {
  state = {
    phoneNumber: "",
    error: false,
  }

  handleFormChange = evt => {
    this.setState({
      phoneNumber: evt.target.value,
    })
  }

  flashMessage = message => {
    window.appendFlash(message)
    this.props.closeModal(true)
  }

  onSubmit = () => {
    if (!verifyPhoneNumber(this.state.phoneNumber)) {
      this.setState({
        error: true,
      })
      return
    }

    sendDownloadLink(
      this.state.phoneNumber,
      this.props.applet.applet_type,
      this.props.forApplet
    )
      .then(data => {
        let message
        if (
          data.errors &&
          data.errors[0].message === "User has already received an SMS"
        ) {
          message = "You have reached your SMS limit. Please try again later."
        } else if (data.status === "success") {
          message = "Message sent successfully."
        } else {
          message = "This message could not be sent."
        }

        this.flashMessage(message)
      })
      .catch(() => {
        this.flashMessage("This message could not be sent.")
      })
  }

  render() {
    return (
      <div className={styles["sms-form"]}>
        <div className={styles["download-apps"]}>
          {/* Platform-specific applets get only their store's badge */}
          {this.props.applet.applet_type !== "android" && (
            <button
              type="button"
              className={styles["store-badge"]}
              aria-label="Download on the App Store"
              onClick={() => {
                window.open(this.props.appStorePath, "_blank", "noopener,noreferrer")
              }}
            >
              {parse(iosSvg)}
            </button>
          )}
          {this.props.applet.applet_type !== "ios" && (
            <button
              type="button"
              className={styles["store-badge"]}
              aria-label="Get it on Google Play"
              onClick={() => {
                window.open(this.props.googlePlayStorePath, "_blank", "noopener,noreferrer")
              }}
            >
              {parse(androidSvg)}
            </button>
          )}
        </div>

        {this.state.error ? (
          <p className={classnames("body-medium", styles["error-message"])}>
            Please enter a valid phone number.
          </p>
        ) : (
          <p className="body-medium">or enter your phone number</p>
        )}

        <div className={styles.field}>
          <input
            name="phone"
            type="tel"
            aria-label="Phone number"
            placeholder="+1 555 555 5555"
            onChange={evt => this.handleFormChange(evt)}
          />
        </div>

        <button
          type="submit"
          className={`button-tertiary button-label-h5 ${styles["sms-form-submit"]}`}
          onClick={this.onSubmit}
        >
          Send link
        </button>

        <button
          type="button"
          className={classnames("text-h5", styles.cancel)}
          onClick={() => this.props.closeModal(false)}
        >
          Cancel
        </button>
      </div>
    )
  }
}

SMSForm.propTypes = {
  applet: PropTypes.shape({
    id: PropTypes.string,
    applet_type: PropTypes.string,
  }),
  appStorePath: PropTypes.string.isRequired,
  forApplet: PropTypes.bool,
  googlePlayStorePath: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
}

SMSForm.defaultProps = {
  forApplet: true,
}
